import { Component, OnInit, signal } from "@angular/core";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SpinnerLoaderComponent } from "../../../../shared/components/spinner-loader/spinner-loader.component";
import { finalize } from "rxjs";
import { ISettingsApiItem } from "../../../../Utils/_models/settings.model";
import { SelectModule } from "primeng/select";
import { SettingService } from "../../../../Utils/_services/admin/settings/settings.service";
import { PlanModalComponent } from "../plan-modal/plan-modal.component";

@Component({
  selector: "app-settings-grid",
  standalone: true,
  imports: [
    CurrencyPipe,
    CommonModule,
    FormsModule,
    SelectModule,
    SpinnerLoaderComponent,
    PlanModalComponent
],
  templateUrl: "./settings-grid.component.html",
  styleUrl: "./settings-grid.component.css",
})
export class SettingsGridComponent implements OnInit {
  constructor(private settingService: SettingService) {}

  plans = signal<ISettingsApiItem[]>([]);
  allSelected: boolean = false;
  loader = signal(false);
  isView = signal<boolean>(false);
  selectedPlan = signal<any | null>(null);
  currentSortField = signal<
    "name" | "price" | null
  >(null);
  currentSortOrder = signal<"asc" | "desc" | null>(null);

  ngOnInit(): void {
    this.loadData();
  }

  onSort(field: "name" | "price"): void {
    if (this.currentSortField() === field) {
      if (this.currentSortOrder() === "asc") {
        this.currentSortOrder.set("desc");
      } else if (this.currentSortOrder() === "desc") {
        this.currentSortOrder.set(null);
        this.currentSortField.set(null);
      }
    } else {
      this.currentSortField.set(field);
      this.currentSortOrder.set("asc");
    }
    this.loadData();
  }

  getSortIcon(field: string): string {
    if (this.currentSortField() !== field) return "⇅";
    if (this.currentSortOrder() === "asc") return "↑";
    if (this.currentSortOrder() === "desc") return "↓";
    return "⇅";
  }

  loadData() {
    this.loader.set(true);

    const sort = this.currentSortField();
    const sortOrder = this.currentSortField() ? this.currentSortOrder() : null;
    this.settingService
      .getAll(sort, sortOrder)
      .pipe(finalize(() => this.loader.set(false)))
      .subscribe({
        next: res => {
          this.plans.set(res.data.plans);
        },
        error: err => {
          console.error("Error fetching plans:", err);
        },
      });
  }

  updateSelectAllState() {
    const selectedCount = this.plans().filter(log => log.selected).length;
    this.allSelected =
      selectedCount === this.plans().length && this.plans().length > 0;
  }

  toggleSelectAll() {
    this.allSelected = !this.allSelected;
    this.plans().forEach(x => (x.selected = this.allSelected));
  }

  getFrequencyLabel(duration: number): string {
    switch (duration) {
      case 7:
        return "Weekly";
      case 30:
        return "Monthly";
      case 90:
        return "Quarterly";
      case 180:
        return "Half-Yearly";
      case 365:
        return "Yearly";
      default:
        return `Every ${duration} days`;
    }
  }

  viewDetails(plan: any)
  {
    this.selectedPlan.set(plan);
    this.isView.set(true);
  }

  closeViewDetails(value: boolean) {
    
    this.isView.set(false);
    this.selectedPlan.set(null);
  }
}
